import React from 'react';

import TextInputWithError from '../TextInputWithError/TextInputWithError';

export const PasswordInput = ({ value, onChange, ...rest }) => (
  <TextInputWithError
    type="password"
    placeholder="Password"
    value={value}
    onChange={onChange}
    {...rest}
  />
)

export default PasswordInput;
